type StringLike = string | { toString: () => string }

export const toTitleCase = (string: StringLike) => {
  const _string = `${string}` //if has toString it will be used here
  const regex = /[a-zA-Z]/
  const forceLowerCaseWords = ['and', 'or', 'for', 'of', 'the']
  Object.freeze(forceLowerCaseWords)

  let result = _string
    .split('')
    .map((value, index, array) => {
      const prevChar = array[index - 1]
      const prevCharIsLetter = regex.test(prevChar)
      if (prevChar && prevCharIsLetter) {
        return value.toLocaleLowerCase()
      } else {
        return value.toLocaleUpperCase()
      }
    })
    .join('')

  forceLowerCaseWords.forEach((word) => {
    //word with whitespace characters before and optionally after
    const regex = new RegExp(`\\s(${word})(\\W|$)`, 'ig')
    const match = regex.exec(result)
    if (match) {
      result = result.replace(regex, match[0].toLocaleLowerCase())
    }
  })

  return result
}
